import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import SelectStates from '../../../../../components/FormInputs/SelectStates';
import { store as mainStore } from '../../../../../store';
import { store } from './reducer';

const SearchBox = () => {
  const {
    state: {
      search: { title, state },
    },
    dispatch,
  } = useContext(store);
  const { showMessage, showError } = useContext(mainStore);

  const handleChangeCityName = (e) => {
    const { value } = e.target;
    dispatch({ type: 'SEARCH_CITY_NAME', payload: value });
  };
  const handleSelectState = (selectedState) => {
    dispatch({ type: 'SEARCH_BY_STATE', payload: selectedState?.value });
  };
  return (
    <Grid container direction="row" spacing={1}>
      <Grid item xs={12} md={6}>
        <TextField
          value={title || ''}
          onChange={handleChangeCityName}
          label="نام شهر ..."
          fullWidth
          variant="outlined"
          size="small"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <SelectStates state={state} onSelect={handleSelectState} height={40} />
      </Grid>
    </Grid>
  );
};

export default React.memo(SearchBox);
